import {themeConstants} from "../constants/themeConstants";

function getInitialState() {
    try {
        return {isDarkMode: localStorage.getItem(themeConstants.STORAGE_KEY) !== 'false'};
    } catch {
        return {isDarkMode: true};
    }
}

const themeReducer = (state = getInitialState(), action = {}) => {
    switch (action.type) {
        case themeConstants.SET_DARK_MODE:
            return {...state, isDarkMode: action.isDarkMode};
        default:
            return state;
    }
};

export default themeReducer;
